

const apiRequester = async (method, endpoint, data = null) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const url = `${baseUrl}${endpoint}`;
  const token = localStorage.getItem("authToken");
  const isLoginRequest = endpoint.toLowerCase().includes("login");
  const headers = {
    Accept: "/",
    "Content-Type": "application/json"
  };

  try {
    let response;
    if (method === "GET" || method === "DELETE") {
      response = await fetch(url, {
        method,
        headers,
      });
    } else if (method === "POST" || method === "PUT") {
      response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data),
      });
    }

    if (response.ok) {
      if (response.headers.get("content-type").includes("text/plain")) {
        return await response.text();
      } else {
        return await response.json();
      }
    } else {
      throw (
        `Error ${response?.status}: Data Not Found` || `Error: Not Found`
      );
    }
  } catch (error) {
    throw error;
  }
};

export default apiRequester;
